<template>
  <section class="achievement-showcase" aria-labelledby="achievement-title">
    <div class="achievement-shell">
      <div class="gold-line top"></div>
      <div class="gold-line bottom"></div>

      <div class="achievement-heading">
        <div class="brand-mark">
          <img src="/static/img/logo.png" alt="云帆培优" />
          <span>云帆培优</span>
        </div>

        <div class="headline">
          <div class="eyebrow">2026 石家庄自主招生</div>
          <h2 id="achievement-title">云帆优秀学员录取名单</h2>
          <p>以长期扎实的培养体系，见证优秀学员在自主招生中的持续突破。</p>
        </div>

        <div class="summary-card">
          <span>录取喜报</span>
          <strong>40<span>人</span></strong>
          <p>二中本部、二南、一中自主招生录取名单完整展示</p>
        </div>
      </div>

      <div class="school-panels">
        <article
          v-for="school in schools"
          :key="school.label"
          class="school-panel"
          :class="school.kind"
        >
          <div class="school-title">
            <div>
              <span>{{ school.label }}</span>
              <strong>{{ school.title }}</strong>
            </div>
            <em>{{ school.students.length }}人</em>
          </div>

          <div class="student-grid" :class="'cols-' + school.columns">
            <div
              v-for="(name, index) in school.students"
              :key="school.title + name"
              class="student-chip"
            >
              <span>{{ String(index + 1).padStart(2, "0") }}</span>
              <strong>{{ name }}</strong>
            </div>
          </div>
        </article>
      </div>

      <p class="source-note">名单依据云帆培优 2026 石家庄自主招生录取喜报整理，姓名按原喜报隐私规则展示。</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "AchievementShowcase",
  data() {
    return {
      schools: [
        {
          label: "二中本部",
          title: "自主招生录取名单",
          kind: "featured",
          columns: 4,
          students: [
            "李*牧", "王*琳", "刘*凯", "张*朗",
            "倪*熙", "郑*阳", "宋*庥", "邢*勋",
            "郑*芮", "张*昕", "丁*", "李*曦",
            "贾*佳", "李*硕", "刘*麟", "闫*航",
            "刘*天", "李*朔", "梁*纶",
          ],
        },
        {
          label: "二南",
          title: "自主招生录取名单",
          kind: "balanced",
          columns: 3,
          students: [
            "贾*宇", "张*宇", "赵*宁",
            "张*轩", "张*熙", "宋*睿",
            "高*萱", "郭*彤", "王*然",
          ],
        },
        {
          label: "一中",
          title: "自主招生录取名单",
          kind: "balanced",
          columns: 4,
          students: [
            "朱*毅", "张*嘉", "王*牛", "陈*岩",
            "张*兮", "杜*茂", "李*轩", "完*祺",
            "刘*怡", "郝*雅", "孟*祺", "陈*钰",
          ],
        },
      ],
    };
  },
};
</script>

<style scoped>
.achievement-showcase {
  height: 1900px;
  left: 0;
  position: absolute;
  top: 1080px;
  width: 1920px;
}

.achievement-shell {
  background:
    radial-gradient(circle at 14% 18%, rgba(255, 213, 128, 0.22), transparent 24%),
    radial-gradient(circle at 88% 16%, rgba(255, 101, 82, 0.2), transparent 28%),
    linear-gradient(135deg, #720006 0%, #ad0715 42%, #d01022 100%);
  color: #fff6dc;
  min-height: 1900px;
  overflow: hidden;
  padding: 72px 150px 96px;
  position: relative;
}

.achievement-shell::before {
  background:
    linear-gradient(115deg, rgba(255, 255, 255, 0), rgba(255, 225, 150, 0.18), rgba(255, 255, 255, 0)),
    radial-gradient(ellipse at center, rgba(255, 245, 202, 0.22), transparent 64%);
  content: "";
  height: 1280px;
  position: absolute;
  right: -210px;
  top: 100px;
  transform: rotate(-18deg);
  width: 960px;
}

.achievement-shell::after {
  background:
    radial-gradient(circle, rgba(255, 236, 177, 0.95) 0 2px, transparent 3px),
    radial-gradient(circle, rgba(255, 236, 177, 0.7) 0 1px, transparent 2px);
  background-position: 0 0, 22px 28px;
  background-size: 92px 96px, 74px 82px;
  content: "";
  inset: 0;
  opacity: 0.16;
  pointer-events: none;
  position: absolute;
}

.gold-line {
  background: linear-gradient(90deg, transparent, rgba(255, 232, 168, 0.82), transparent);
  height: 1px;
  left: 150px;
  position: absolute;
  right: 150px;
  z-index: 1;
}

.gold-line.top {
  top: 54px;
}

.gold-line.bottom {
  bottom: 54px;
}

.achievement-heading,
.school-panels,
.source-note {
  position: relative;
  z-index: 1;
}

.achievement-heading {
  align-items: center;
  display: grid;
  gap: 42px;
  grid-template-columns: 300px 1fr 320px;
}

.brand-mark {
  align-items: center;
  display: flex;
  gap: 18px;
}

.brand-mark img {
  background: rgba(255, 255, 255, 0.94);
  border-radius: 50%;
  height: 72px;
  object-fit: contain;
  padding: 8px;
  width: 72px;
}

.brand-mark span {
  color: #fff8e6;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 40px;
  font-weight: 600;
  line-height: 52px;
  white-space: nowrap;
}

.headline {
  text-align: center;
}

.eyebrow {
  color: #ffe5a7;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 34px;
  font-weight: 600;
  letter-spacing: 12px;
  line-height: 44px;
}

h2 {
  color: #fff4d4;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 58px;
  font-weight: 600;
  letter-spacing: 8px;
  line-height: 78px;
  margin: 16px 0 0;
  text-shadow: 0 8px 26px rgba(66, 0, 0, 0.3);
}

.headline p {
  color: rgba(255, 246, 220, 0.84);
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 19px;
  line-height: 32px;
  margin: 16px 0 0;
}

.summary-card {
  background: linear-gradient(145deg, rgba(255, 248, 222, 0.95), rgba(255, 223, 154, 0.82));
  border: 1px solid rgba(255, 252, 232, 0.9);
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(92, 0, 0, 0.24);
  color: #8c0b0b;
  padding: 22px 28px 24px;
}

.summary-card span {
  display: block;
  font-family: "PingFang SC-Medium", Helvetica;
  font-size: 17px;
  line-height: 24px;
}

.summary-card strong {
  display: block;
  font-family: "Poppins", "PingFang SC", Helvetica;
  font-size: 72px;
  font-weight: 700;
  line-height: 76px;
  margin-top: 4px;
}

.summary-card strong span {
  display: inline;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  margin-left: 4px;
}

.summary-card p {
  color: #8c0b0bcc;
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 15px;
  line-height: 24px;
  margin: 8px 0 0;
}

.school-panels {
  display: grid;
  gap: 24px;
  margin-top: 58px;
}

.school-panel {
  background: linear-gradient(145deg, rgba(255, 248, 226, 0.13), rgba(255, 255, 255, 0.05));
  border: 1px solid rgba(255, 226, 164, 0.34);
  border-radius: 8px;
  box-shadow: 0 22px 66px rgba(70, 0, 0, 0.18);
  padding: 30px 36px 34px;
}

.school-panel.featured {
  background: linear-gradient(145deg, rgba(255, 246, 216, 0.18), rgba(255, 255, 255, 0.06));
}

.school-title {
  align-items: flex-end;
  border-bottom: 1px solid rgba(255, 227, 166, 0.36);
  display: flex;
  justify-content: space-between;
  padding-bottom: 22px;
}

.school-title span {
  color: #ffe4a1;
  display: block;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 4px;
  line-height: 38px;
}

.school-title strong {
  color: #fff9e9;
  display: block;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 40px;
  font-weight: 600;
  line-height: 54px;
  margin-top: 2px;
}

.school-title em {
  background: rgba(255, 235, 178, 0.14);
  border: 1px solid rgba(255, 229, 170, 0.35);
  border-radius: 999px;
  color: #ffe6a6;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 20px;
  font-style: normal;
  line-height: 28px;
  padding: 9px 20px;
}

.student-grid {
  display: grid;
  gap: 14px;
  margin-top: 24px;
}

.student-grid.cols-3 {
  grid-template-columns: repeat(3, 1fr);
}

.student-grid.cols-4 {
  grid-template-columns: repeat(4, 1fr);
}

.student-chip {
  align-items: center;
  background: linear-gradient(135deg, rgba(255, 244, 211, 0.96), rgba(255, 225, 160, 0.86));
  border: 1px solid rgba(255, 253, 235, 0.72);
  border-radius: 8px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.38), 0 14px 28px rgba(77, 0, 0, 0.12);
  display: flex;
  min-height: 66px;
  padding: 0 20px;
}

.student-chip span {
  color: rgba(143, 11, 11, 0.58);
  font-family: "Poppins", Helvetica;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  margin-right: 18px;
  width: 28px;
}

.student-chip strong {
  color: #8d0a0a;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  white-space: nowrap;
}

.source-note {
  color: rgba(255, 245, 218, 0.7);
  font-family: "PingFang SC-Regular", Helvetica;
  font-size: 16px;
  line-height: 26px;
  margin: 28px 0 0;
  text-align: center;
}
</style>
